import {getAllCountries, getAllStatesInCountry} from 'state-country';

export const allCountries = getAllCountries().map((a) => ({
  value: a.name,
  label: a.name,
}));

export const findStateFromCountry = (country) =>
  getAllStatesInCountry(country?.value || country).map((a) => ({
    value: a.name,
    label: a.name,
  }));
